import { gql } from '@parkchirp/api-client';

export const CREATE_FEE = gql`
  mutation createFee(
    $feeName: String!
    $feeTypeId: Int!
    $type: FeeTypeEnum!
    $facilityId: ID!
    $calculationType: FeeCalculationTypeEnum!
    $feesHistory: [FeeHistoryInput]!
    $accessDeviceTypeId: Int,
    $vehicleTypeId: Int
  ) {
    createFee(
      feeName: $feeName,
      feeTypeId: $feeTypeId,
      type: $type,
      facilityId: $facilityId,
      calculationType: $calculationType,
      feesHistory: $feesHistory,
      accessDeviceTypeId: $accessDeviceTypeId,
      vehicleTypeId: $vehicleTypeId
    )
  }
`;

export const UPDATE_FEE = gql`
  mutation updateFee(
    $id: ID!
    $feeName: String!
    $facilityId: String!
    $feesHistory: [UpdateFeeHistoryInput]!
    $vehicleTypeId: Int
  ) {
    updateFee(
      id: $id,
      feeName: $feeName,
      facilityId: $facilityId,
      feesHistory: $feesHistory,
      vehicleTypeId: $vehicleTypeId
    )
  }
`;
